import {
    ChangeDetectionStrategy,
    Component,
    model,
    ModelSignal,
    OnDestroy,
    OnInit,
    signal,
    WritableSignal,
} from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { RouterService } from "../../../../shared/_services/router.service";
import { TradingSymbolsListsService, TradingSymbolsListView } from "../_services/trading-symbols-lists.service";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-trading-symbols-lists",
    templateUrl: "./trading-symbols-lists.component.html",
    styleUrl: "./trading-symbols-lists.component.scss",
    standalone: false,
})
export class TradingSymbolsListsComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject<any>();

    public symbolsLists: ModelSignal<TradingSymbolsListView[]> = model<TradingSymbolsListView[]>([]);
    public isLoaded: WritableSignal<boolean> = signal<boolean>(false);
    public displayedColumns: string[] = ["name", "actions"];

    constructor(
        private router: RouterService,
        private tradingSymbolsListsService: TradingSymbolsListsService,
    ) {}

    ngOnInit(): void {
        this.tradingSymbolsListsService
            .list()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((lists: TradingSymbolsListView[]) => {
                this.symbolsLists.set(lists);
                this.isLoaded.set(true);
            });
    }

    public create(): void {
        this.router.navigate("/trading-symbols-lists/new");
    }

    public edit(item: TradingSymbolsListView): void {
        this.router.navigate(`/trading-symbols-lists/${item.id}`);
    }

    public delete(item: TradingSymbolsListView): void {
        this.tradingSymbolsListsService
            .delete(item.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
                this.symbolsLists.set(this.symbolsLists().filter((list) => list.id !== item.id));
            });
    }

    ngOnDestroy(): void {
        // prevent memory leak when component destroyed
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
